document.addEventListener('DOMContentLoaded', () => {
  initGrHomeBenefitsSplit();
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initGrHomeBenefitsSplit(event?.target);
  });
}

function initGrHomeBenefitsSplit(root = document) {
  const splitInstances = root.querySelectorAll ? root.querySelectorAll('.js-gr-home-benefits-split') : [];

  if (!splitInstances.length && root.classList?.contains('js-gr-home-benefits-split')) {
    splitInstances.push(root);
  }

  if (!splitInstances.length) return;

  splitInstances.forEach((instance) => {
    const buttons = Array.from(instance.querySelectorAll('.gr-home-variant-button[data-variant-index]'));
    const buyForm = instance.querySelector('.gr-home-benefits-buy-form');
    const buyVariantIdInput = buyForm ? buyForm.querySelector('input[name="id"]') : null;
    const buySubmitButton = buyForm ? buyForm.querySelector('button[type="submit"]') : null;
    const mediaItems = Array.from(instance.querySelectorAll('.gr-home-benefits-media__item[data-variant-index]'));
    const textItems = Array.from(instance.querySelectorAll('.gr-home-benefits-swap__text-item[data-variant-index]'));

    if (!buttons.length) return;

    function setActiveVariant(variantIndex) {
      const selectedButton = buttons.find(
        (button) => String(button.dataset.variantIndex) === String(variantIndex)
      );
      const selectedCartVariantId = selectedButton ? selectedButton.dataset.cartVariantId : '';

      buttons.forEach((button) => {
        const isActive = String(button.dataset.variantIndex) === String(variantIndex);
        button.classList.toggle('gr-home-button--primary', isActive);
        button.classList.toggle('gr-home-button--secondary', !isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      mediaItems.forEach((item) => {
        const isActive = String(item.dataset.variantIndex) === String(variantIndex);
        item.classList.toggle('is-active', isActive);
      });

      textItems.forEach((item) => {
        const isActive = String(item.dataset.variantIndex) === String(variantIndex);
        item.classList.toggle('is-active', isActive);
      });

      if (buyVariantIdInput) buyVariantIdInput.value = selectedCartVariantId || '';
      if (buySubmitButton) {
        const shouldDisable = !selectedCartVariantId;
        buySubmitButton.disabled = shouldDisable;
        buySubmitButton.toggleAttribute('disabled', shouldDisable);
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => setActiveVariant(button.dataset.variantIndex));
    });

    setActiveVariant('0');
  });
}

